import { SINO_NUM_60_69 } from "../../../../SubjectData/BasicWords/Numbers/SinoNums.js";
import "../../../Deck.css";
import FlashcardInterface from "../../../Flashcard_Interface.js";
import HeaderNav from "../../../../Components/Header/Header_Nav/Header_Nav.js";

export default function SINO_NUM_60_69_DECK() {
  return (
    <>
      <HeaderNav GoBack_to="/NumbersNav" />
      <FlashcardInterface deckData={SINO_NUM_60_69} title="Sino Numbers: 60-69" />
    </>
  );
}
